import Component from "vue-class-component";
import Vue from "vue";
import { ApplicationViews } from "@/util/enum";

@Component({})
export default class Container extends Vue {
	get padding(): boolean {
		return !this.$route.meta?.hasOwnProperty("containerPadding") ? true : this.$route.meta.containerPadding;
	}
	get removeContainer(): boolean {
		return !this.$route.meta?.hasOwnProperty("removeContainer") ? false : this.$route.meta.removeContainer;
	}

	get hasHeight(): boolean {
		return (
			this.$route.meta.viewId === ApplicationViews.ObjectiveManager ||
			this.$route.meta.viewId === ApplicationViews.ContentObjective ||
			this.$route.meta.viewId == ApplicationViews.ConversationBuilder ||
			this.$route.meta.viewId == ApplicationViews.FocusWordsTab
		);
	}

	get hasHeight80(): boolean {
		return this.$route.meta.viewId === ApplicationViews.MasterPlan ||
			this.$route.meta.viewId === ApplicationViews.LessonPlanList;
	}
}
